export default "__VITE_ASSET__BZfb_u4k__"